import { createSlice } from "@reduxjs/toolkit";
import { UserBookSerializersUserBook } from "types/serializers";

export type BookButtonStateType = {
  open: boolean;
  bookId: number;
  referrerUserId: number;
  isLoaded: boolean;
  userBookStatusMap: Record<number, number> | null;
};

export const bookButtonState: BookButtonStateType = {
  open: false,
  bookId: null,
  referrerUserId: null,
  isLoaded: false,
  userBookStatusMap: undefined,
};

const bookButtonSlice = createSlice({
  name: "BookButtonSlice",
  initialState: bookButtonState,
  reducers: {
    showBookDrawer(
      state,
      {
        payload: { bookId, referrerUserId },
      }: {
        payload: {
          bookId: number;
          referrerUserId?: number;
        };
      }
    ) {
      state.open = true;
      state.bookId = bookId;
      state.referrerUserId = referrerUserId;
    },
    isLoaded(state) {
      state.isLoaded = true;
    },
    hideBookDrawer(state) {
      state.open = false;
      state.bookId = null;
      state.referrerUserId = null;
    },
    reset(state) {
      state.bookId = null;
      state.referrerUserId = null;
    },
    setUserBookStatusMap(state, { payload }: { payload: Record<number, number> | undefined }) {
      state.userBookStatusMap = payload;
    },
    setUserBook(
      state,
      { payload: { userBook } }: { payload: { userBook: UserBookSerializersUserBook } }
    ) {
      state.userBookStatusMap[userBook.bookId] = userBook.statusId;
    },
    removeUserBook(state, { payload: { bookId } }: { payload: { bookId: number } }) {
      delete state.userBookStatusMap[bookId];
    },
  },
});

export const bookButtonActions = bookButtonSlice.actions;

export default bookButtonSlice.reducer;
